import { AlertTriangle } from "lucide-react"

import { formatToBRL } from "@/utils/formatToMoney"

import {
  DIVERGENT_ICON_CLASSES,
  DTEF_COMPARISON_ROW_ARIA_DIVERGENT,
  DTEF_RESUME_ROW_LABEL_SUFFIX,
} from "../constants"

interface DtefComparisonRowProps {
  label: string
  varValue: number
  dtefValue: number
  divergent: boolean
}

const DIVERGENT_LABEL_CLASSES =
  "font-semibold break-words text-red-700 inline-flex items-center gap-1"
const ALIGNED_LABEL_CLASSES = "font-semibold break-words"
const DIVERGENT_VALUE_CLASSES =
  "text-right ml-2 shrink-0 text-red-700 font-semibold"
const ALIGNED_VALUE_CLASSES = "text-right ml-2 shrink-0"

export function DtefComparisonRow({
  label,
  varValue,
  dtefValue,
  divergent,
}: DtefComparisonRowProps) {
  const labelClass = divergent ? DIVERGENT_LABEL_CLASSES : ALIGNED_LABEL_CLASSES
  const valueClass = divergent ? DIVERGENT_VALUE_CLASSES : ALIGNED_VALUE_CLASSES

  return (
    <>
      <div className="flex justify-between items-start">
        <p className={labelClass}>
          {divergent && (
            <AlertTriangle
              className={DIVERGENT_ICON_CLASSES}
              aria-label={DTEF_COMPARISON_ROW_ARIA_DIVERGENT}
            />
          )}
          {label}:
        </p>
        <p className={valueClass}>{formatToBRL(varValue)}</p>
      </div>
      <div className="flex justify-between items-start">
        <p className={labelClass}>
          {divergent && (
            <AlertTriangle
              className={DIVERGENT_ICON_CLASSES}
              aria-hidden="true"
            />
          )}
          {label} {DTEF_RESUME_ROW_LABEL_SUFFIX}:
        </p>
        <p className={valueClass}>{formatToBRL(dtefValue)}</p>
      </div>
    </>
  )
}
